import { Button } from "@mui/material";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FaCircle } from "react-icons/fa";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import { useChangePasswordMutation, useUserChangePasswordMutation } from "../../../Service/settings";
import Toast from "../../../Component/DigitalMarketing/Toast";
import PermissionCheck from "../../../Component/PermissionCheck";

function UserPasswordChange({ form }) {
  const initialState = {
    mobileNumber:""
  };
  const [password, setPassword] = useState(initialState);
  const { open, message, openSnackBar, type } = useSnackbar();
  const [submit, setSubmit] = useState(false);
  const [err, setError] = useState("");
  const [changePassword,{ isLoading:updateLoading }] = useUserChangePasswordMutation();

  const handleChange = (event) => {
    let { name, value } = event.target;
    
    if (name === 'mobileNumber' ) {
      value = value.replace(/[^0-9]/g, '');
      value = value.slice(0, 10);
    }
    setSubmit(false);
    setPassword((prevState) => ({ ...prevState, [name]: value }));
  };
  const handleSubmit = async () => {
    setSubmit(true);
    if (
      password.mobileNumber.trim().length === 10
    ) {
      try {
        const payload = await changePassword(password).unwrap();
        // console.log("fulfilled", payload);
        openSnackBar("Updated successfully");
        setSubmit(false);
        setPassword(initialState);
        setError("");
      } catch (error: any) {
        // openSnackBar(error.data.message, "error");
        setError(error.data.message);
        console.error("rejected", error);
      }
    }
    else {
      openSnackBar("Enter correct phone number","error");

    }
  };
  return (
    <div className="mx-3 mt-2">
      <p>
        <b>Password Update</b>
      </p>
      <Row>
        <Toast open={open} type={type} message={message} />
        <Col md={6} className="mb-2">
          {err && <span className="center red-c">{err}</span>}
          {form.map((a, i) => {
            return (
              <div key={i} className="mb-2">
                <a.tag
                  {...a}
                  maxChar={a.maxChar}
                  {...password}
                  // style={PermissionCheck("settings", "update") ? "" : "input-grey"}
                  // disab={PermissionCheck("settings", "update") ? false : true}
                  submit={submit}
                  handleChange={handleChange}
                />
              </div>
            );
          })}
        </Col>
        <Col md={6} className="password-rules mb-2">
          <div>
            <ul className="grey">
              <li>
                <p className="black">  <FaCircle className="blue-circle" />After password update, user's phone number will be changed as their password </p>
              </li>
             
              <li>
                <FaCircle className="blue-circle" />
                A Whatsapp notification will be sent
              </li>
            </ul>
          </div>
        </Col>
          <Col md={12} className="mb-2">
            <div>
              <Button
                variant="outlined"
                onClick={() => setPassword(initialState)}
                className="me-2"
                id="btn-outline"
              >
                Cancel
              </Button>
              <Button variant="contained" disabled={updateLoading} onClick={handleSubmit} id="btn-add">
                {updateLoading?"Wait":"Update Password"}
              </Button>
            </div>
          </Col>
      </Row>
    </div>
  );
}

export default UserPasswordChange;
